<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <h1 class="mb-2 text-center page-title">AVISO DE PRIVACIDAD</h1>

      <p class="mb-2">
        En AVIP, nos comprometemos a proteger la privacidad de nuestros usuarios y la seguridad de su información personal. Este Aviso de Privacidad describe cómo recopilamos, usamos, compartimos y protegemos su información cuando visita nuestro sitio web y utiliza nuestros servicios de venta de boletos.
      </p>

      <br />
      <h5>1. Información que Recopilamos</h5>
      <p>
        Recopilamos información personal que usted nos proporciona cuando:
      </p>
      <ul>
        <li>
          Se registra en nuestro sitio web.
        </li>
        <li>
          Realiza una compra de boletos.
        </li>
        <li>
          Se suscribe a nuestro boletín de noticias.
        </li>
        <li>
          Se comunica con nosotros para consultas o soporte.
        </li>
      </ul>

      <br />
      <p>
        La información que recopilamos incluye, pero no se limita a:
      </p>
      <ul>
        <li>
          Nombre
        </li>
        <li>
          Correo electrónico
        </li>
        <li>
          Número de teléfono
        </li>
        <li>
          Dirección de envío
        </li>
        <li>
          Datos de pago (número de tarjeta de crédito/débito, fecha de vencimiento y código de seguridad)
        </li>
        <li>
          Información de preferencias de usuario
        </li>
      </ul>

      <br />
      <p>
        También podemos recopilar información automáticamente mediante cookies y tecnologías similares cuando usted interactúa con nuestro sitio web, incluyendo su dirección IP y datos sobre su navegación.
      </p>

      <br />
      <h5>2. Uso de su Información</h5>
      <p>
        Utilizamos la información recopilada para los siguientes propósitos:
      </p>
      <ul>
        <li>Procesar y confirmar su compra de boletos.</li>
        <li>Enviar confirmaciones de compra y actualizaciones sobre sus transacciones.</li>
        <li>Proporcionar servicio al cliente y soporte.</li>
        <li>Enviar comunicaciones, promociones y ofertas relevantes.</li>
        <li>Mejorar nuestros servicios y la experiencia del usuario a través de análisis y estadísticas.</li>
      </ul>

      <br />
      <h5>3. Compartición de su Información</h5>
      <p>
        No compartiremos su información personal con terceros sin su consentimiento, excepto en los siguientes casos:
      </p>
      <ul>
        <li>Con proveedores de servicios que procesen su información por nosotros (por ejemplo, procesadores de pagos, servicios de envío) con la única finalidad de llevar a cabo su solicitud.</li>
        <li>Si es requerido por la ley o en respuesta a un proceso legal.</li>
        <li>Para proteger nuestros derechos, privacidad y seguridad, así como los derechos, privacidad y seguridad de los demás.</li>
      </ul>

      <br />
      <h5>4. Seguridad de su Información</h5>
      <p>
        Implementamos medidas de seguridad adecuadas para proteger su información personal contra el acceso no autorizado, la divulgación o el uso inadecuado. Sin embargo, ningún método de transmisión por Internet ni almacenamiento electrónico es 100% seguro. Nos esforzamos por utilizar medios comercialmente aceptables para proteger su información, pero no podemos garantizar su seguridad absoluta.
      </p>

      <br />
      <h5>5. Sus Derechos</h5>
      <p>
        Usted tiene derechos sobre su información personal, incluyendo el derecho a acceder, corregir o eliminar su información. Si desea ejercer alguno de estos derechos, por favor contáctenos a través de la información proporcionada a continuación.
      </p>

      <br />
      <h5>6. Cambios a este Aviso de Privacidad</h5>
      <p>
        Nos reservamos el derecho de actualizar este Aviso de Privacidad en cualquier momento. Notificaremos a los usuarios sobre cambios significativos publicando el nuevo Aviso de Privacidad en esta página con una nueva fecha de revisión.
      </p>

      <br />
      <h5>7. Contacto</h5>
      <p>
        Si tiene preguntas o inquietudes sobre este Aviso de Privacidad o sobre nuestras prácticas de privacidad, por favor contáctenos en: ayuda@avip.online
      </p>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/privacidad')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
